/* eslint-disable @typescript-eslint/no-empty-function */
import {
  Component,
  EventEmitter,
  forwardRef,
  input,
  Output,
  output,
} from '@angular/core';
import {
  ControlValueAccessor,
  FormsModule,
  NG_VALUE_ACCESSOR,
} from '@angular/forms';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'app-radio-button',
  imports: [FormsModule],
  standalone: true,
  templateUrl: './radio-button.component.html',
  styleUrls: [
    './radio-button.component.scss',
    './blue-radio-style.scss',
    'select-radio-style.scss',
  ],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: forwardRef(() => RadioButtonComponent),
    },
  ],
})
export class RadioButtonComponent implements ControlValueAccessor {
  @Output() optionSelected = new EventEmitter<any>();
  name = input<string>('');

  index = input.required<number>();

  variant = input<'green' | 'blue' | 'select'>('green');

  optionValue = input.required<any>();

  tabbable = input(true);

  includeResetOption = input(true);

  resetClicked = output<void>();

  touched = false;

  disabled = false;

  value: any;

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  onChange: (value: any) => void = (value: any) => {};

  onTouched = () => {};

  writeValue(value: any) {
    this.value = value;
    this.onChange!(this.value);
  }

  registerOnChange(onChange: any) {
    this.onChange = onChange;
  }

  registerOnTouched(onTouched: any) {
    this.onTouched = onTouched;
  }

  markAsTouched() {
    if (!this.touched) {
      this.onTouched();
      this.touched = true;
    }
  }

  setDisabledState(disabled: boolean) {
    this.disabled = disabled;
  }

  selectOption(option: any) {
    this.optionSelected.emit(option);
  }
}
